import { FormattedMessage } from 'react-intl';

import { Rarity, type Sport } from '@sorare/core/src/__generated__/globalTypes';
import { iconCart } from '@sorare/core/src/atoms/icons/system/iconCart.ts';
import { iconGavel } from '@sorare/core/src/atoms/icons/system/iconGavel.ts';
import { iconTransfer } from '@sorare/core/src/atoms/icons/system/iconTransfer.ts';
import {
  ANY_SPORT_MARKET_SHOP_AUCTIONS,
  ANY_SPORT_MARKET_SHOP_INSTANT_BUY,
  ANY_SPORT_MARKET_SHOP_MANAGER_SALES,
} from '@sorare/core/src/constants/__generated__/routes';
import { navLabels, transferMarket } from '@sorare/core/src/lib/glossary';

import type { MarketTab } from '#src/components/market/MarketTabBar/index.tsx';
import { MarketTabBar } from '#src/components/market/MarketTabBar/index.tsx';
import { getMarketShopUrl } from '#src/lib/marketShopRoutes.ts';

type Props = {
  rarity: Rarity;
  sport: Sport;
};

export const MarketShopTabs = ({ rarity, sport }: Props) => {
  if ([Rarity.custom_series, Rarity.common].includesValue(rarity)) {
    return null;
  }

  const tabs: MarketTab[] = [
    {
      to: getMarketShopUrl(ANY_SPORT_MARKET_SHOP_AUCTIONS, { sport, rarity }),
      icon: iconGavel,
      label: <FormattedMessage {...navLabels.auctions} />,
    },
    {
      to: getMarketShopUrl(ANY_SPORT_MARKET_SHOP_INSTANT_BUY, {
        sport,
        rarity,
      }),
      icon: iconCart,
      label: <FormattedMessage {...transferMarket.instantBuy} />,
    },
    {
      to: getMarketShopUrl(ANY_SPORT_MARKET_SHOP_MANAGER_SALES, {
        sport,
        rarity,
      }),
      icon: iconTransfer,
      label: <FormattedMessage {...transferMarket.transfer} />,
    },
  ];

  return <MarketTabBar tabs={tabs} />;
};
